const { DPSBaseUrl } = window.__conf__;

export const sendEmailWithRecommendationsService = async (data) => {
    const response = await fetch(
        `${DPSBaseUrl}/recommender/fetch/recommended/emailNotification`,
        {
            method: 'POST',
            body: JSON.stringify({
                ...data,
            }),
            headers: {
                'Content-Type': 'application/json',
                Channel: 'WEB',
                'App-Id': 'DPS',
                'Correlation-ID':
                    sessionStorage.getItem('correlationId'),
            },
        },
    );
    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }
    const finalResponse = await response.json();
    return finalResponse;
};
